<div class="adx-widget-header-bar">
  @if (showTitle) {
    <span class="adx-widget-header-title" [title]="title">{{ title }}</span>
  }
  <span></span>
  <span class="adx-widget-header-actions" [class.adx-widget-header-actions--collapsible]="isCollapsible">
    <!-- toggle fullscreen mode -->
    @if (canToggleFullscreen) {
      <button mat-icon-button class="adx-widget-header-action" [ngClass]="iconButtonClass"
        aria-label="Fullscreen-Button" (click)="fullscreenToggle.emit()">
        <fa-icon [ngClass]="faIconClass" [icon]="isFullscreen ? 'compress' : 'expand'"></fa-icon>
      </button>
    }
    <!-- open the widget in its own browser window or screen -->
    @if (canOpenInWindow && !isFullscreen) {
      <button mat-icon-button class="adx-widget-header-action" [ngClass]="iconButtonClass"
        aria-label="Open-In-Window-Button" [title]="'APP.WIDGET_VIEW' | translate"
        [matMenuTriggerFor]="screenMenu" (click)="loadScreenDetails()"
        (menuOpened)="menuOpenChange.emit(true)" (menuClosed)="menuOpenChange.emit(false)">
        <fa-icon [ngClass]="faIconClass" [icon]="'desktop'"></fa-icon>
      </button>
      <mat-menu #screenMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="openInWindow.emit(undefined)">
            <fa-icon class="adx-widget-header-menu-icon" [icon]="'up-right-from-square'"></fa-icon>
            <span>{{ "APP.WIDGET_WINDOW" | translate }}</span>
        </button>
        @for (screen of screens; track $index) {
          <button mat-menu-item (click)="openInWindow.emit(screen)">
            <fa-icon class="adx-widget-header-menu-icon" [icon]="'desktop'"></fa-icon>
            <span>{{ "APP.WIDGET_ON_SCREEN" | translate }} {{ $index + 1 }}</span>
          </button>
        }
      </mat-menu>
    }
    <!-- close the browser window that shows this widget -->
    @if (canCloseWindow) {
      <button mat-icon-button class="adx-widget-header-action" [ngClass]="iconButtonClass"
        aria-label="Close-Window-Button" [title]="'APP.WIDGET_CLOSE_WINDOW' | translate"
        (click)="closeWindow.emit()">
        <fa-icon [ngClass]="faIconClass" [icon]="'arrow-right-from-bracket'"></fa-icon>
      </button>
    }
    <!-- open settings component -->
    @if (canOpenSettings) {
      <button mat-icon-button class="adx-widget-header-action" [ngClass]="iconButtonClass"
        aria-label="Settings-Button" (click)="settingsOpen.emit()">
        <fa-icon [ngClass]="faIconClass" [icon]="'bars'"></fa-icon>
      </button>
    }
    <!-- remove widget -->
    @if (canRemove) {
      @if (variant === "grid") {
        <button mat-icon-button class="adx-widget-header-action" [ngClass]="iconButtonClass"
          aria-label="Close-Button"
          (mousedown)="onRemove($event)"
          (touchstart)="onRemove($event)">
          <fa-icon [ngClass]="faIconClass" [icon]="'xmark'"></fa-icon>
        </button>
      } @else {
        <button mat-icon-button class="adx-widget-header-action" [ngClass]="iconButtonClass"
          aria-label="Close-Button" (click)="onRemove($event)">
          <fa-icon [ngClass]="faIconClass" [icon]="'xmark'"></fa-icon>
        </button>
      }
    }

    <!-- The same actions, grouped, for widgets too narrow to show them side by side. Not inside
         an @if: a re-render there would destroy the open menu. CSS hides it instead. -->
    <button mat-icon-button class="adx-widget-header-overflow" [ngClass]="iconButtonClass"
      [attr.aria-label]="'APP.WIDGET_ACTIONS' | translate"
      [matMenuTriggerFor]="overflowMenu"
      (menuOpened)="menuOpenChange.emit(true);loadScreenDetails()"
      (menuClosed)="menuOpenChange.emit(false)">
      <fa-icon [ngClass]="faIconClass" [icon]="'ellipsis-vertical'"></fa-icon>
    </button>
    <mat-menu #overflowMenu="matMenu" xPosition="before">
      @if (canToggleFullscreen) {
        <button mat-menu-item (click)="fullscreenToggle.emit()">
          <fa-icon class="adx-widget-header-menu-icon" [icon]="isFullscreen ? 'compress' : 'expand'"></fa-icon>
          <span>{{ (isFullscreen ? "APP.WIDGET_FULLSCREEN_EXIT" : "APP.WIDGET_FULLSCREEN") | translate }}</span>
        </button>
      }
      @if (canOpenInWindow && !isFullscreen) {
        <button mat-menu-item (click)="loadScreenDetails()"
          [matMenuTriggerFor]="overflowScreenMenu">
          <fa-icon class="adx-widget-header-menu-icon" [icon]="'desktop'"></fa-icon>
          <span>{{'APP.WIDGET_VIEW' | translate}}</span>
        </button>
        <mat-menu #overflowScreenMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="openInWindow.emit(undefined)">
              <fa-icon class="adx-widget-header-menu-icon" [icon]="'up-right-from-square'"></fa-icon>
              <span>{{ "APP.WIDGET_WINDOW" | translate }}</span>
          </button>
          @for (screen of screens; track $index) {
            <button mat-menu-item (click)="openInWindow.emit(screen)">
              <fa-icon class="adx-widget-header-menu-icon" [icon]="'desktop'"></fa-icon>
              <span>{{ "APP.WIDGET_ON_SCREEN" | translate }} {{ $index + 1 }}</span>
            </button>
          }
        </mat-menu>
      }
      @if (canCloseWindow) {
        <button mat-menu-item (click)="closeWindow.emit()">
          <fa-icon class="adx-widget-header-menu-icon" [icon]="'arrow-right-from-bracket'"></fa-icon>
          <span>{{ "APP.WIDGET_CLOSE_WINDOW" | translate }}</span>
        </button>
      }
      @if (canOpenSettings) {
        <button mat-menu-item (click)="settingsOpen.emit()">
          <fa-icon class="adx-widget-header-menu-icon" [icon]="'bars'"></fa-icon>
          <span>{{ "APP.WIDGET_SETTINGS" | translate }}</span>
        </button>
      }
      @if (canRemove) {
        <button mat-menu-item (click)="onRemove($event)">
          <fa-icon class="adx-widget-header-menu-icon" [icon]="'xmark'"></fa-icon>
          <span>{{ "APP.WIDGET_REMOVE" | translate }}</span>
        </button>
      }
    </mat-menu>
  </span>
</div>
